

module.exports = __webpack_require__.stylable.create(
    "ColorOption2215770673",
    {"classes":{"root":"ColorOption2215770673__root","colorOption":"ColorOption2215770673__colorOption"},"vars":{},"stVars":{"selectedBorderColor":"'\"fallback(color(--gallery_titleTextColor), opacity(color(color-5), 0.6))\"'"},"keyframes":{}},
    "",
    12,
    "ColorOption2215770673",
    null
);
